import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { DesignAngularKitModule } from 'design-angular-kit';
import { FindRequestDto } from '../../models/find-request.dto';
import { PatientDto, RequestDto } from '../../models/request.dto';
import { AuthService } from '../../services/auth.service';
import { RequestService } from '../../services/request.service';
import { PatientService } from '../../services/patient.service';
import { RequestSummaryComponent } from '../../components/request-summary/request-summary.component';
import { ContextService } from '../../services/context.service';

@Component({
  selector: 'app-dashboard-mmg',
  standalone: true,
  imports: [
    CommonModule,
    DesignAngularKitModule,
    RouterModule,
    RequestSummaryComponent
  ],
  templateUrl: './dashboard-mmg.component.html',
  styleUrl: './dashboard-mmg.component.scss',
})
export class DashboardMmgComponent implements OnInit, OnDestroy {
 patient: PatientDto | undefined;
 request: any;
  constructor(
    private requestService: RequestService,
    public authService: AuthService,
    private route: ActivatedRoute,
    private patientService: PatientService,
    private router: Router,
    public context: ContextService
  ) {}

  ngOnInit(): void {
    if(this.context.patientFiscalCode) {
      this.loadPatient(this.context.patientFiscalCode!); 
    }  
  }

  ngOnDestroy(): void {

  }

  loadPatient(fiscalCode: string) {
     const payload = {
      anagraficaAssistito: {
        codiceFiscale: fiscalCode.toUpperCase(),
      },
      anagraficaApplicativo: {
        codFiscOperatore: '',
        codiceApplicativo: 'YEFARYWRCX',
        nomeApplicativo: 'we-com',
      },
    };
    this.patientService.findPatient(payload).subscribe((response) => {
      if (response && response?.patient) {
        this.patient = response?.patient ;
        this.request = {patient: this.patient};
      } else {
        console.log('paziente non trovato');
      }
    });
  }

  viewTransitions() {
    this.router.navigate(['/request-list'], {
      queryParams: {patientFiscalCode : this.context.patientFiscalCode}
  });
  }

  newRequest() {
    this.router.navigate(['/request-new']);
  }

}
